import { IIamConfig } from '@one/app/shared/services/auth/iam-config.models';
import { InjectionToken } from '@angular/core';

export const IAM_CONFIG = new InjectionToken<IIamConfig>('IAM config');
